import { useCallback, useState } from "react";
import type { ListBatchJobItemsParams } from "../../../../lib/corpusApi";

/** What every kind's tab has: its label, and the item filters it lists by. */
export interface BatchJobTabConfig {
  label: string;
  /** Query params sent to GET /batch-jobs/:id/items for this tab. */
  apiFilters: Pick<ListBatchJobItemsParams, "status" | "review" | "outcome">;
}

export interface UseBatchJobTabsResult<Key extends string, Config extends BatchJobTabConfig> {
  activeTab: Key;
  setActiveTab: (tab: Key) => void;
  /** The active tab's config. */
  tab: Config;
}

/** Tracks which of a kind's tabs is showing. */
export function useBatchJobTabs<Key extends string, Config extends BatchJobTabConfig>(
  tabs: Record<Key, Config>,
  initial: NoInfer<Key>
): UseBatchJobTabsResult<Key, Config> {
  const [activeTab, setActiveTabRaw] = useState<Key>(initial);
  const setActiveTab = useCallback((next: Key) => setActiveTabRaw(next), []);
  return { activeTab, setActiveTab, tab: tabs[activeTab] };
}
